<template>
  <div style="margin-top: 20px; margin-bottom: 20px;">
    <h2 class="u">
      Редактировать подъезд
    </h2>
    <div class="sub-nav">
      <router-link class="btn btn-default btn-sm" :to="{ name: 'block-details', params: { block_id: block.id }}">← Назад к Деталям подъезда</router-link>
    </div>

    <div class="text-right">
      <a v-if="block.id" class="red" href="#" @click.prevent="deleteBlock">удалить подъезд</a>
    </div>

    <block-edit-form
      :block="block"
      @after="handleAfter"
    />

  </div>
</template>

<script>
import { getBlock, deleteBlock } from '@/services/block.service'
import blockEditForm from '@/components/forms/block/BlockEditForm'

export default {
  name: 'block-edit',
  components: { blockEditForm },
  data () {
    return {
      block: {
        id: null,
        number: '',
        full_name: '',
        building: ''
      },

      errors: {
        block: {
          id: [],
          number: [],
          building: []
        },
        non_field_errors: []
      }
    }
  },
  mounted () {
    if (this.$route.params.block_id !== undefined) {
      this.block.id = this.$route.params.block_id

      getBlock(this.block.id).then((response) => {
        this.block = response.data
      })
    }
  },
  methods: {
    deleteBlock () {
      deleteBlock(this.block.id).then((response) => {
        this.showMsg('Подъезд был удален!', 'success', 'Успешно')
        this.$router.push({ name: 'building-details', params: { building_id: this.$route.params.building_id } })
        return true
      }).catch(err => {
        console.log(err)
        this.showMsg('Подъезд был удален!', 'success', 'Успешно')
        this.$router.push({ name: 'building-details', params: { building_id: this.$route.params.building_id } })
        return true
      })
    },
    handleAfter (success) {
      console.log(success)
    },
    showMsg (text, type, title) {
      let foundRoot = false
      let $parent = this.$parent

      while (!foundRoot) {
        console.log($parent)
        if ($parent.$parent.$parent === undefined) {
          foundRoot = true
          $parent.showPopupMsg(text, type, title)
        } else {
          $parent = $parent.$parent
        }
      }
    }
  }
}
</script>


// WEBPACK FOOTER //
// BlockEdit.vue?ff5b496a